import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableSelectBox({ items, onDeselect, format, onDeselectAll, selectAllToggle = null, selectedAll = null }) {

    const selectedItems = items.map(
        (item, index) => <div key={index} className={'selected-item'}>
            {format(item)}
            <span className="la-Incorrect" onClick={() => onDeselect(item)}></span>
        </div>
    )

    const noItems = <div>No items selected</div>

    const selectedItemsHeader = <div className="selection-dropdown-header">
        <FormattedMessage id='General_CoreFunctionality_UIText_tableSelectBox.selectedItems'/>
        <span className="button-doc-sm clear-all-btn" onClick={onDeselectAll}>
            <FormattedMessage id='General_CoreFunctionality_UIText_tableSelectBox.clearAll'/>
        </span>
    </div>

    const selectAllCheck = <input type="checkbox"
                                  disabled={!selectAllToggle}
                                  className="select-all-checkbox"
                                  onClick={selectAllToggle} checked={!!selectedAll} />;

    return (
        <span className="tableSelectBox listed">
            { selectAllCheck }
            <label className="la-TriangleDown">
                <span>{items.length}</span>
                <div className="dropdown-content">
                    {items.length ? selectedItemsHeader : null}
                    <div className={"selected-items"}>
                        {items.length ? selectedItems : noItems}
                    </div>
                </div>
            </label>
        </span>
    );

}

export default TableSelectBox;


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/Components/TableSelectBox.jsx